import AxiosInitializer from 'api/Utility/AxiosInitializer'
import getToken from 'lib/authentication/GetToken'
import apiWrapper from 'api/Utility/ApiWrapper'
import { handleStatus500 } from 'api/Utility/HandleStatus500'

const axiosRequest = (extraParams: any = {}) => {
  const params = {
    token: getToken(),
    paramsSerializerConfig: true,
    ...extraParams,
  }

  return AxiosInitializer({
    ...params,
  })
}

const defaultParam = {
  filterable: true,
  per_page: 999,
  filters: { sort: { name: 'asc' } },
}

const GetHubsURL = `/hubs`

const hubsEndPoint = {
  getHubs: (params: any) => {
    return axiosRequest().get(GetHubsURL, { params })
  },
}

const hubsAPI = {
  getHubs: (params = defaultParam) =>
    apiWrapper({
      endPoint: hubsEndPoint.getHubs,
      params,
      errorFailureAction: handleStatus500,
    }),
}

export default hubsAPI
